// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_al-3";
export var contentContainer = "_al-0";
export var editorContainer = "_al-1";
export var quillInputForm = "_al-2";
export var zoneDivider = "_al-4";